import React from "react";
import { Container, Row, Col } from "reactstrap";

const DiscountBannerOmg = () => {
  return (
    <section className="discount-banner">
      <Container>
        <Row>
          <Col lg="12">
            <div className="discount-banner-contain">
              <h2>Strength, Stability, Precision and Reliability</h2>
              <h1>
                <span>Find your product with</span> <span>Alderberry!</span>
              </h1>
              <div className="rounded-contain rounded-inverse">
                <div className="rounded-subcontain">We provide trusted, high-quality products to ensure reliable clinical results.</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DiscountBannerOmg;
